import Api from './Api';

const productsLinesService = {

  get: (  ) => {

    return Api.get( '/products/lines', {
      withCredentials: true
    } )
  },
  post: ( jsonData ) => {

      return Api.post( '/products/lines', jsonData, {
        withCredentials: true
      } )

  },
  delete: ( usersID ) => {

    return Api.delete( `/products/lines/${ JSON.stringify( usersID ) }`, {
      withCredentials: true
    })
  }

}

export default productsLinesService
